var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c("div", { staticClass: "row no-gutters mx-0 home" }, [
      _c("div", { staticClass: "col" }, [
        !_vm.showError &&
        _vm.homePageData.Error &&
        this.homePageData.fields !== null
          ? _c("div", { staticClass: "alert alert-danger" }, [
              _c(
                "div",
                { staticClass: "my-0 w-100", attrs: { role: "alert" } },
                [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col d-inline-block my-auto payment-error p-0",
                        attrs: { "aria-level": "3" }
                      },
                      [
                        _c("strong", [_vm._v("Payment Error: ")]),
                        _vm._v(
                          _vm._s(_vm.homePageData.Error.Message) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        this.homePageData.fields === null
          ? _c("div", { staticClass: "row px-4", attrs: { id: "errorMsg" } }, [
              _vm._m(1)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.getters.getRcHomeStatusError
          ? _c("div", { staticClass: "row px-4", attrs: { id: "errorMsg" } }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 pt-3 pb-2 mb-3 mt-3 text-white text-center bg-danger",
                  attrs: { "aria-level": "3" }
                },
                [
                  _c("h1", [
                    _vm._v(_vm._s(_vm.$store.getters.getRcHomeStatusErrorData))
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "row no-gutters" }, [
          _vm.homeCarrierFinalRateSection &&
          _vm.homeCarrierFinalRateSection.premium_amount
            ? _c("div", { staticClass: "col-12 mx-auto" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-6 pr-4" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "border-green rounded-bottom border-thick"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "carrier-logo mx-auto text-center mt-2 mb-0"
                          },
                          [
                            _c("img", {
                              staticStyle: { "max-width": "8rem" },
                              attrs: {
                                src: this.homeCarrierFinalRateSection.logo_path
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "final-rate mx-auto text-center text-primary font-weight-bold"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm._f("currency-filter")(
                                    this.homeCarrierFinalRateSection
                                      .premium_amount
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-center smaller-font-content text-gray"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                this.homeCarrierFinalRateSection.policy_term
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "text-center smaller-font-content text-danger-checkout my-2 mx-4"
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(this.homeCarrierFinalRateSection.blurb) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-6 px-4" }, [
                    _c("h3", { staticClass: "text-center text-gray py-2" }, [
                      _vm._v("Original Quoted Rate")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "quote text-center text-gray font-weight-bold"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency-filter")(
                              this.homeCarrierFinalRateSection
                                .original_premium_amount
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-center smaller-font-content text-gray"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            this.homeCarrierFinalRateSection
                              .original_policy_term
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "quote-adjust smaller-font-content text-gray mt-3",
                      domProps: {
                        innerHTML: _vm._s(
                          this.homeCarrierFinalRateSection
                            .premium_adjustment_reason
                        )
                      }
                    })
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.homePaymentPlanFields && _vm.homePaymentPlanFields.length > 0
            ? _c("div", { staticClass: "col-12 pt-4" }, [
                _c(
                  "div",
                  { staticClass: "shadow-sm" },
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-1",
                            attrs: { "header-tag": "header", role: "tab" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle.HomePaymentOptions",
                                    modifiers: { HomePaymentOptions: true }
                                  }
                                ],
                                attrs: { block: "", variant: "primary" }
                              },
                              [
                                _c("span", { staticClass: "card-heading" }, [
                                  _c("span", {
                                    staticClass: "fas fa-home mr-1"
                                  }),
                                  _vm._v(
                                    "\n                    Payment Options\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "toggle-icon",
                                    attrs: { "data-v-87cda704": "" }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "toggle-down fas fa-b-angle-down ",
                                      attrs: { "data-v-87cda704": "" }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "toggle-up fas fa-b-angle-up",
                                      attrs: { "data-v-87cda704": "" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            attrs: {
                              id: "HomePaymentOptions",
                              visible: "",
                              accordion: "HomePaymentOptions",
                              role: "tabpanel"
                            }
                          },
                          [
                            _c(
                              "b-card-body",
                              [
                                _c(
                                  "b-card-text",
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "QTE_PRP_BillPlan"
                                            ),
                                            expression:
                                              "errors.has('QTE_PRP_BillPlan')"
                                          }
                                        ],
                                        staticClass: "row mx-0 mt-2 no-gutters"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-12 d-inline-block"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "small mt-3 mb-1 p-2 form-error"
                                              },
                                              [
                                                _c("span", [
                                                  _c("strong", [
                                                    _vm._v("Required:")
                                                  ]),
                                                  _vm._v(
                                                    " Please select a payment option."
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row mx-0 mt-2 no-gutters"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 d-inline-block text-faint-gray"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "star" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(
                                              "If the customer is ready to buy, proceed with the following payment options. "
                                            ),
                                            this.homePageData.page_name.includes(
                                              "nwid"
                                            )
                                              ? [
                                                  _vm._v(
                                                    "“Installment” options are non-auto pay and require a one-time payment due today, and future payments are submitted through your Nationwide online account."
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.homePaymentPlanFields, function(
                                      item,
                                      key
                                    ) {
                                      return _c(
                                        "div",
                                        { key: key, staticClass: "w-100" },
                                        [
                                          _vm.newHeader(
                                            key,
                                            _vm.homePaymentPlanFields,
                                            item.sub_section
                                          )
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row mt-2 px-2 py-1 bg-homeback text-dark-gray no-gutters"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-12",
                                                        attrs: {
                                                          role: "heading",
                                                          "aria-level": "4"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.sub_section
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row py-1 smaller-font-content font-weight-bold bg-light text-center text-dark-gray no-gutters"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col border-right"
                                                      },
                                                      [_vm._v("Payment Option")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-2 border-right"
                                                      },
                                                      [_vm._v("Savings")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-2 border-right"
                                                      },
                                                      [_vm._v("You Pay Today")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-2 border-right"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Future Payments"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-2" },
                                                      [
                                                        _vm._v("Total"),
                                                        [_vm._v(" Price")]
                                                      ],
                                                      2
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row py-1 payment-item text-faint-gray no-gutters",
                                              attrs: { id: "pay-full-1" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col border-right smaller-font-content font-weight-bold text-black"
                                                },
                                                [
                                                  _c("form-block", {
                                                    staticClass: "form-group",
                                                    attrs: { formdata: item }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-2 border-right text-center"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-green font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "currency-filter"
                                                          )(item.savings)
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-gray sm-txt"
                                                    },
                                                    [_vm._v("Discount")]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-2 border-right text-black text-center"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "currency-filter"
                                                          )(item.downpayment)
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.downpayment_subtext
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-gray sm-txt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.downpayment_subtext
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-2 border-right text-center"
                                                },
                                                [
                                                  item.numpayments > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-gray sm-txt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.numpayments
                                                            ) + " Payments"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-faint-gray my-1"
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "currency-filter"
                                                            )(
                                                              item.installment_amount
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.installment_amount_subtext
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-gray sm-txt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.installment_amount_subtext
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-2 text-center"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-primary font-weight-bold text-qs-blue"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "currency-filter"
                                                          )(item.total_cost)
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.total_cost_subtext
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-gray sm-txt"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.total_cost_subtext
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  item.bill_plan
                                                    ? _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "cursorBox btn-sm btn-outline-primary d-inline-block smaller-font-content center mt-2",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.openBreakdownModal(
                                                                "breakdownHeader-" +
                                                                  item.bill_plan
                                                                    .bill_plan_id
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v("Breakdown")]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          item.bill_plan
                                            ? _c(
                                                "modal",
                                                {
                                                  attrs: {
                                                    name:
                                                      "breakdownHeader-" +
                                                      item.bill_plan
                                                        .bill_plan_id,
                                                    height: "auto",
                                                    scrollable: true,
                                                    focusTrap: "true"
                                                  },
                                                  on: {
                                                    opened: function($event) {
                                                      return _vm.modalOpened(
                                                        "breakdownModal"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("Trap", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "breakdown-modal-top pt-2 pl-3 pr-2 product-section-heading text-white"
                                                      },
                                                      [
                                                        _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "breakdown-modal-header"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.label)
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "a",
                                                          {
                                                            ref:
                                                              "breakdownModal",
                                                            refInFor: true,
                                                            staticClass:
                                                              "cursorBox fa-stack uniform-icon-breakdown",
                                                            attrs: {
                                                              href:
                                                                "JavaScript:void(0);",
                                                              id:
                                                                "breakdownModal",
                                                              name:
                                                                "breakdownModal"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.closeBreakdownModal(
                                                                  "breakdownHeader-" +
                                                                    item
                                                                      .bill_plan
                                                                      .bill_plan_id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("span", {
                                                              staticClass:
                                                                "fas fa-circle fa-stack-2x",
                                                              staticStyle: {
                                                                color: "#fff"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", {
                                                              staticClass:
                                                                "fas fa-times fa-stack-1x",
                                                              staticStyle: {
                                                                color: "#1C3664"
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("img", {
                                                    staticClass:
                                                      "carrier-logo pl-3 my-2",
                                                    attrs: {
                                                      src:
                                                        item.bill_plan.logo_url
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pl-3 pr-3 pb-3"
                                                    },
                                                    [
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "table table-sm table-striped mb-0 w-100"
                                                        },
                                                        [
                                                          _c(
                                                            "thead",
                                                            {
                                                              staticClass:
                                                                "blueWhiteHeaderFooter smaller-font-content "
                                                            },
                                                            [
                                                              _c("tr", [
                                                                _c(
                                                                  "th",
                                                                  {
                                                                    attrs: {
                                                                      scope:
                                                                        "col"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Installment"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "th",
                                                                  {
                                                                    attrs: {
                                                                      scope:
                                                                        "col"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Date"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "th",
                                                                  {
                                                                    attrs: {
                                                                      scope:
                                                                        "col"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Amount"
                                                                    )
                                                                  ]
                                                                )
                                                              ])
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "tbody",
                                                            {
                                                              staticClass:
                                                                "breakdown-table-body"
                                                            },
                                                            _vm._l(
                                                              item.bill_plan
                                                                .bill_plan_installments,
                                                              function(
                                                                installment,
                                                                installmentKey
                                                              ) {
                                                                return _c(
                                                                  "tr",
                                                                  {
                                                                    key: installmentKey
                                                                  },
                                                                  [
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          installment.installment_name
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          installment.installment_date
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          installment.amount
                                                                        )
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "tfoot",
                                                            {
                                                              staticClass:
                                                                "blueWhiteHeaderFooter product-section-heading text-white"
                                                            },
                                                            [
                                                              _c("tr", [
                                                                _c("td"),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticStyle: {
                                                                      "text-align":
                                                                        "right"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Total:"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item
                                                                        .bill_plan
                                                                        .bill_plan_total
                                                                    )
                                                                  )
                                                                ])
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.homeBllingInformationSection
            ? _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "shadow-sm" },
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-1",
                            attrs: { "header-tag": "header", role: "tab" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle.HomeBillingInfo",
                                    modifiers: { HomeBillingInfo: true }
                                  }
                                ],
                                attrs: { block: "", variant: "primary" }
                              },
                              [
                                _c("span", { staticClass: "card-heading" }, [
                                  _c("span", {
                                    staticClass: "fas fa-home mr-1"
                                  }),
                                  _vm._v(
                                    "\n                    Billing Information\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "toggle-icon",
                                    attrs: { "data-v-87cda704": "" }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "toggle-down fas fa-b-angle-down ",
                                      attrs: { "data-v-87cda704": "" }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "toggle-up fas fa-b-angle-up",
                                      attrs: { "data-v-87cda704": "" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            attrs: {
                              id: "HomeBillingInfo",
                              accordion: "HomeBillingInfo",
                              role: "tabpanel"
                            }
                          },
                          [
                            _c(
                              "b-card-body",
                              [
                                _c("b-card-text", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row w-100 mx-0 no-gutters"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-12 col-md-6 pr-2" },
                                        [
                                          _vm._l(
                                            _vm.homePageFieldsArray,
                                            function(item, key) {
                                              return [
                                                item.section ==
                                                "Billing Information"
                                                  ? _c(
                                                      "div",
                                                      { key: key },
                                                      [
                                                        _vm.newHeader(
                                                          key,
                                                          _vm.homePageFieldsArray,
                                                          item.sub_section
                                                        )
                                                          ? _c(
                                                              "div",
                                                              {
                                                                key: key + "2",
                                                                staticClass:
                                                                  "row mx-0 my-2 py-1 product-section-heading text-white"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-12",
                                                                    attrs: {
                                                                      role:
                                                                        "heading",
                                                                      "aria-level":
                                                                        "4"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.sub_section
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("form-block", {
                                                          key: key,
                                                          staticClass:
                                                            "form-group",
                                                          attrs: {
                                                            formdata: item,
                                                            vgsStatus:
                                                              _vm.homeVgsStatus
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-12 col-md-6 pl-2" },
                                        [
                                          _vm._l(
                                            _vm.homeCarrierPaymentInformationSection,
                                            function(item, key) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    key: key,
                                                    staticClass: "rounded-top",
                                                    class: {
                                                      "bg-green": !_vm.isBlue(
                                                        item.section
                                                      ),
                                                      "bg-primary": _vm.isBlue(
                                                        item.section
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "text-center text-white py-2 mb-0"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.section)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    key: key + "2",
                                                    staticClass:
                                                      "rounded-bottom border-thick pb-2 mb-3",
                                                    class: {
                                                      "border-green": !_vm.isBlue(
                                                        item.section
                                                      ),
                                                      "border-primary": _vm.isBlue(
                                                        item.section
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "final-rate mx-auto text-center text-primary font-weight-bold"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                              " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "currency-filter"
                                                              )(
                                                                item.payment_amount
                                                              )
                                                            ) +
                                                            "\n                            "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass:
                                                        "text-center smaller-font-content",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          item.blurb
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center mx-auto my-3 w-100"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "alert alert-warning my-0 py-2 w-100",
                                              attrs: { role: "note" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "row no-gutters"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-inline-block pr-2 my-auto"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          width: "25px",
                                                          height: "25px",
                                                          src: require("../../../assets/exclamation-circle-yellow-new.svg"),
                                                          alt: "info"
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col d-inline-block my-auto smaller-font-content"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mb-0 text-dark-gray"
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              "Confirm Payment Information:"
                                                            )
                                                          ]),
                                                          _vm._v(
                                                            " Confirm the amounts of today’s payment and any future monthly payments with the customer."
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.homeCheckoutSection
            ? _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "shadow-sm" },
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-1",
                            attrs: { "header-tag": "header", role: "tab" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle.homeCheckoutSection",
                                    modifiers: { homeCheckoutSection: true }
                                  }
                                ],
                                attrs: { block: "", variant: "primary" }
                              },
                              [
                                _c("span", { staticClass: "card-heading" }, [
                                  _c("span", {
                                    staticClass: "fas fa-home mr-1"
                                  }),
                                  _vm._v(
                                    "\n                    Billing Information\n                  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "toggle-icon",
                                    attrs: { "data-v-87cda704": "" }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "toggle-down fas fa-b-angle-down ",
                                      attrs: { "data-v-87cda704": "" }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "toggle-up fas fa-b-angle-up",
                                      attrs: { "data-v-87cda704": "" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            attrs: {
                              id: "homeCheckoutSection",
                              accordion: "homeCheckoutSection",
                              role: "tabpanel"
                            }
                          },
                          [
                            _c(
                              "b-card-body",
                              [
                                _c("b-card-text", [
                                  _c(
                                    "div",
                                    { staticClass: "row w-100  mx-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-11 w-60 alert alert-primary  py-2  .mb-4",
                                          attrs: { role: "note" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "row no-gutters" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-inline-block pr-2 my-auto"
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      width: "20px",
                                                      height: "20px",
                                                      src: require("../../../assets/info-circle-blue.svg"),
                                                      alt: "info"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "col d-inline-block my-auto smaller-font-content",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.homeInfoContent()
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.homePdfLinkCov && _vm.homePdfLinkCov[0]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex  mx-3 justify-content-center "
                                        },
                                        [
                                          _vm.homePdfLinkCov &&
                                          _vm.homePdfLinkCov.length > 1 &&
                                          _vm.homePdfLinkCov[0]
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn mb-2 mr-3 btn-btn btn-outline-primary",
                                                  attrs: {
                                                    type: "button",
                                                    role: "button"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.homeRedirectToCoverage(
                                                        _vm.homePdfLinkCov[0]
                                                          .field_value
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.homePdfLinkCov[0]
                                                        .label
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.homePdfLinkCov &&
                                          _vm.homePdfLinkCov.length === 1 &&
                                          _vm.homePdfLinkCov[0]
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn mb-2 btn-btn btn-primary",
                                                  attrs: {
                                                    type: "button",
                                                    role: "button"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.homeRedirectToCoverage(
                                                        _vm.homePdfLinkCov[0]
                                                          .field_value
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.homePdfLinkCov[0]
                                                        .label
                                                    ) +
                                                      "\n                        "
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "fa fa-open-in-new ml-1"
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            viewBox:
                                                              "0 0 16 16",
                                                            fill: "currentColor"
                                                          }
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d:
                                                                "M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z",
                                                              fill:
                                                                "currentColor"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.homePdfLinkCov &&
                                          _vm.homePdfLinkCov[1]
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn mb-2 btn-btn btn-primary",
                                                  attrs: {
                                                    type: "button",
                                                    role: "button"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.homeRedirectToCoverage(
                                                        _vm.homePdfLinkCov[1]
                                                          .field_value
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.homePdfLinkCov[1]
                                                        .label
                                                    ) +
                                                      "\n                        "
                                                  ),
                                                  _c(
                                                    "i",
                                                    {
                                                      staticClass:
                                                        "fa fa-open-in-new ml-1"
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            viewBox:
                                                              "0 0 16 16",
                                                            fill: "currentColor"
                                                          }
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              d:
                                                                "M9.33333 2V3.33333H11.7267L5.17333 9.88667L6.11333 10.8267L12.6667 4.27333V6.66667H14V2M12.6667 12.6667H3.33333V3.33333H8V2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8H12.6667V12.6667Z",
                                                              fill:
                                                                "currentColor"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.homeAcknowledgementSection
            ? _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "shadow-sm" },
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-1",
                            attrs: { "header-tag": "header", role: "tab" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle.HomeAcknowledgements",
                                    modifiers: { HomeAcknowledgements: true }
                                  }
                                ],
                                attrs: { block: "", variant: "primary" }
                              },
                              [
                                _c("span", { staticClass: "card-heading" }, [
                                  _c("span", {
                                    staticClass: "fas fa-home mr-1"
                                  }),
                                  _vm._v(
                                    "\n                    Acknowledgements\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "toggle-icon",
                                    attrs: { "data-v-87cda704": "" }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "toggle-down fas fa-b-angle-down ",
                                      attrs: { "data-v-87cda704": "" }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "toggle-up fas fa-b-angle-up",
                                      attrs: { "data-v-87cda704": "" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            attrs: {
                              id: "HomeAcknowledgements",
                              accordion: "HomeAcknowledgements",
                              role: "tabpanel"
                            }
                          },
                          [
                            _c(
                              "b-card-body",
                              [
                                _c(
                                  "b-card-text",
                                  [
                                    _vm._l(_vm.homePageFieldsArray, function(
                                      item,
                                      qKey
                                    ) {
                                      return [
                                        item.section ===
                                          "Coverage Summary & Approval" &&
                                        item.field_type !== "label"
                                          ? _c(
                                              "div",
                                              { key: qKey },
                                              [
                                                _c("form-block", {
                                                  staticClass: "form-group",
                                                  attrs: { formdata: item }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    }),
                                    _vm._v(" "),
                                    _vm.homeblurbs.formbottom &&
                                    _vm.homeblurbs.formbottom.visible
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center mx-auto mt-3"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-primary my-0 py-2",
                                                attrs: { role: "note" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row no-gutters"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-inline-block pr-2 my-auto"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            width: "25px",
                                                            height: "25px",
                                                            src: require("../../../assets/info-circle-blue.svg"),
                                                            alt: "info"
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass:
                                                        "smaller-font-content d-inline-block my-auto",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          _vm.homeblurbs
                                                            .formbottom.content
                                                        )
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.showError &&
          _vm.homePageData.fields &&
          _vm.homePageData.fields.length > 0
            ? _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "shadow-sm " },
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c(
                          "b-card-header",
                          {
                            staticClass: "p-1",
                            attrs: { "header-tag": "header", role: "tab" }
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle.HomeCoverages",
                                    modifiers: { HomeCoverages: true }
                                  }
                                ],
                                attrs: { block: "", variant: "primary" }
                              },
                              [
                                _c("span", { staticClass: "card-heading" }, [
                                  _c("span", {
                                    staticClass: "fas fa-home mr-1"
                                  }),
                                  _vm._v(
                                    "\n                    Coverage Summary & Approval\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "toggle-icon",
                                    attrs: { "data-v-87cda704": "" }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "toggle-down fas fa-b-angle-down ",
                                      attrs: { "data-v-87cda704": "" }
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "toggle-up fas fa-b-angle-up",
                                      attrs: { "data-v-87cda704": "" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-collapse",
                          {
                            attrs: {
                              id: "HomeCoverages",
                              accordion: "HomeCoverages",
                              role: "tabpanel"
                            }
                          },
                          [
                            _c(
                              "b-card-body",
                              [
                                _c("b-card-text", [
                                  _c("div", { staticClass: "row no-gutters" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center w-100"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-warning my-0 py-2 w-100",
                                                attrs: { role: "note" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row no-gutters"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-inline-block pr-2 my-auto"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            width: "25px",
                                                            height: "25px",
                                                            src: require("../../../assets/exclamation-circle-yellow-new.svg"),
                                                            alt: "info"
                                                          }
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col d-inline-block my-auto smaller-font-content"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "mb-0 text-dark-gray"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Confirm Policy Details:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              " Please confirm the following policy details with the customer. Coverages that are not mentioned are either not offered by the carrier or they were declined by the policyholder."
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.homeblurbs.formCoverageHelp &&
                                        _vm.homeblurbs.formCoverageHelp.visible
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center w-100 mt-3"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "alert alert-primary my-0 py-2 w-100",
                                                    attrs: { role: "note" }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row no-gutters"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-inline-block pr-2 my-auto"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                width: "25px",
                                                                height: "25px",
                                                                src: require("../../../assets/info-circle-blue.svg"),
                                                                alt: "info"
                                                              }
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("div", {
                                                          staticClass:
                                                            "col d-inline-block my-auto smaller-font-content",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.homeblurbs
                                                                .formCoverageHelp
                                                                .content
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        this.homeCarrierFinalRateSection &&
                                        this.homeCarrierFinalRateSection
                                          .logo_path
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row mx-0 mb-1 no-gutters"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "carrier-logo col-6 col-sm-3  mt-2 mb-0"
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        "max-width": "8rem"
                                                      },
                                                      attrs: {
                                                        src: this
                                                          .homeCarrierFinalRateSection
                                                          .logo_path
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row mx-0 mb-1 smaller-font-content no-gutters"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-6 col-sm-3 font-weight-bold"
                                              },
                                              [_vm._v("Policy Start Date")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-6 col-sm-9" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getPolicyStartDate()
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input-link-button-list", {
                                          attrs: {
                                            pdfLinkCovData: _vm.homePdfLinkCov
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "mt-3" },
                                          [
                                            _vm.homePropCov.length > 0
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "py-1 pl-3 mb-2  text-dark-gray bg-homeback ",
                                                      attrs: {
                                                        role: "heading",
                                                        "aria-level": "4"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Property Coverages"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.homePropCov,
                                                    function(pData, pKey) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            key:
                                                              pKey +
                                                              "homePropCov",
                                                            staticClass:
                                                              "row mx-0 mb-2 smaller-font-content"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    pData.label
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 col-md-8 col-xl-6 text-dark-gray"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    pData.text
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  )
                                                ]
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.homePropEndsmt.length > 0
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "py-1 pl-3 mt-3 text-dark-gray bg-homeback ",
                                                      attrs: {
                                                        role: "heading",
                                                        "aria-level": "4"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Property Endorsement"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.homePropEndsmt,
                                                    function(
                                                      propData,
                                                      propKey
                                                    ) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            key:
                                                              propKey +
                                                              "propKey",
                                                            staticClass:
                                                              "row mx-0 mb-2 smaller-font-content"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 col-md-4 col-xl-6 font-weight-bold text-dark-gray"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    propData.label
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-6 col-md-8 col-xl-6 text-dark-gray"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    propData.text
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  )
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.showError
          ? _c(
              "div",
              {
                class: { row: true, "my-3": this.homePageData.fields === null }
              },
              [
                this.homePageData.fields === null ||
                _vm.homePaymentPlanFields.length == 0
                  ? _c(
                      "div",
                      {
                        staticClass: "col-12",
                        attrs: { id: "error-next-step-container" }
                      },
                      [
                        _c("bundle-carrier-error", {
                          attrs: { errorData: _vm.homeBundleCarrierError }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2" }, [
      _c("i", { staticClass: "fa fa-icon-exclamation-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "col-12 pt-3 pb-2 mb-3 text-white text-left bg-danger",
        attrs: { "aria-level": "3" }
      },
      [
        _c("h1", [
          _c("i", { staticClass: "fa fa-icon-exclamation-circle" }),
          _vm._v(" We were unable to proceed due to an error.\n          ")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-green rounded-top" }, [
      _c("h3", { staticClass: "text-center text-white py-2 mb-0" }, [
        _vm._v("Home - Final Rate")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7121c09e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7121c09e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/HomeCheckout.vue
// module id = null
// module chunks = 